import { extend, override } from 'flarum/extend';
import app from 'flarum/app';

import config from '../config';

import SettingsPage from 'flarum/components/SettingsPage';
import WeChatApplication from './components/WeChatApplication';
import UnlinkModal from "./components/UnlinkModal";
import LinkModal from "./components/LinkModal";

import LogInButtons from 'flarum/components/LogInButtons';
import Button from 'flarum/components/Button';
import Application from 'flarum/common/Application';

app.initializers.add(`monsternone/${config.package.name}`, () => {

    extend(SettingsPage.prototype, 'accountItems', (items) => {
        const {
            data: {
                attributes: {
                    WeChatAuth: {
                        isLinked = false
                    },
                },
            },
        } = app.session.user;

        items.add(`link${config.module.id}`,
            <Button className={`Button ${config.module.id}Button--${isLinked ? 'danger' : 'success'}`} icon={config.module.icon}
                path={`/auth/${name}`} onclick={() => app.modal.show(isLinked ? UnlinkModal : LinkModal)}>
                {app.translator.trans(`${config.module.name}.forum.buttons.${isLinked ? 'unlink' : 'link'}`)}
            </Button>
        );
    });

    extend(LogInButtons.prototype, 'items', (items) => {
        items.add(config.package.id,
            <Button
                className={`Button LogInButton--${config.module.id}`}
                icon={config.module.icon}
                onclick={() => window.location.href=`${config.api.uri}`}>
                {app.translator.trans(`${config.module.name}.forum.buttons.login`)}
            </Button>
        );
    });

    extend(Application.prototype, 'updateTitle', function (original) { // 回传title
        wx.miniProgram.postMessage({
            data: {
                title: document.title
            }
        });
    });

});

app.wechat = new WeChatApplication();

window.onload = (event) => {
    let url = new URL(document.location);
    if (url.searchParams.get('miniprogram_login')) {
        app.authenticationComplete(JSON.parse((new URL(document.location)).searchParams.get('miniprogram_login')));
        url.searchParams.delete('miniprogram_login');
        window.history.pushState({},0,url);
    }
}